import { IconChevronRight } from '@tabler/icons-react';

import { MENU_ITEMS } from '@config/menu';

import { LayoutBreadcrumbs } from '@widgets/layout/layout-breadcrumbs';

export const Breadcrumbs: React.FC = () => (
  <LayoutBreadcrumbs
    separator={IconChevronRight} //
    navigation={MENU_ITEMS}
  />
);
